// extracted by mini-css-extract-plugin
var _1 = "FileDirectoryBreadcrumbs-moduleskeleton__rGXaC Skeleton-moduleSkeleton__Mlrfv";
export { _1 as "skeleton" }
